export function timeToHoursMinutesSeconds(time: string, resolution: string): number {
  const timeArray = time.split(':');
  if (timeArray.length !== 3) {
    console.error(new Error('Invalid time format'));
    return 0;
  }

  const hours = parseInt(timeArray[0], 10);
  const minutes = parseInt(timeArray[1], 10);
  const seconds = parseInt(timeArray[2], 10);

  switch (resolution) {
    case 'hours':
      return hours + minutes / 60 + seconds / 3600;
    case 'minutes':
      return hours * 60 + minutes + seconds / 60;
    case 'seconds':
      return hours * 3600 + minutes * 60 + seconds;
    default:
      console.error(new Error('Invalid resolution'));
      return 0;
  }
}
